import CollapsibleTable from "./CollapsibleTable";

export const OpenBankingMonthlyAverages = ({ data }) => {
  if (!data) {
    return null;
  }

  return <CollapsibleTable data={data} />;
};
